import store from "../store";
import { validate } from "vee-validate";

export const validateFamily = async (familyId) => {
  let questions =
    store.getters["notesModule/getRenderedQuestionsByFamily"](familyId);

  // Create an array of Promises returned by the async validate function
  const promises = questions.map((question) => {
    if (question.isGroupQuestion) return validateGroupQuestion(question);
    else
      return validateQuestion(question, question.mappedValidationPluginProps);
  });

  // Wait for all promises to resolve
  const results = await Promise.all(promises);

  // Use the synchronous every() method on the array of boolean results
  return results.flat().every((isTrue) => isTrue);
};

export const validateGroupQuestion = async (question) => {
  // Create inner array of Promises of validated group questions
  const innerPromises = question.childQuestions.map((childQ) => {
    // validate the CHILD QUESTION response against the GROUP question validations
    return validateQuestion(childQ, question.mappedValidationPluginProps);
  });

  // Wait for all inner promises to resolve
  const innerResults = await Promise.all(innerPromises);

  return innerResults;
};

export const validateQuestion = async (question, validations) => {
  let response =
    store.getters["notesModule/getQuestionResponseValue"](
      question.questionId || ""
    ) || [];

  // remove DistinctResposne validation from programmatic call (only used within component itself to disable in dropdown)
  const { DistinctResponse, ...test } = validations;

  // programmatically call to validate the response against the question validations
  return validate(response, test).then((result) => {
    store.commit("notesModule/SET_QUESTION_VALIDATION", {
      questionId: question.questionId,
      isValidationSuccess: result.valid,
    });
    return result.valid;
  });
};
